import { styled, TextField } from "@mui/material"

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '25px',
  }
})

export default StyledTextField;
